<template>
	<section id="investering" class="text-center w-100 bg-white z-index-1 pb-0">
		<b-container class="px-4 pb-lg-5 pt-3">
			<b-row v-view="viewHandler">
				<b-col cols="12" lg="8" offset-lg="2" class="text-center viewer fade px-4">
					<h3 class="pb-3">
						<span v-if="$creo.getLang() == 'sv'">JM som investering</span>
						<span v-else>JM as an investment</span>

					</h3>
					<p class="">
						<span v-if="$creo.getLang() == 'sv'">Ambitionen är att över tid ge våra aktieägare en högre totalavkastning än företag med liknande verksamhet och riskprofil.</span>
						<span v-else>The ambition is to give shareholders over time a higher total return than other companies with a similar risk profile and business activities.</span>
					</p>
				</b-col>
			</b-row>

			<b-row id="charts" class="px-3 px-lg-0 z-index-3 pt-5 position-relative" v-view="viewHandler">
				<b-col cols="12" order="1" md="6" order-md="1" lg="3" order-lg="1" class="px-4 px-md-2 px-lg-4 viewer fade ">
					<h6 class="m-0 pb-4 text-graydark text-uppercase" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<span v-if="$creo.getLang() == 'sv'">TOTALAVKASTNING</span>
						<span v-else>Total return</span>

					</h6>
				</b-col>
				<b-col cols="12" order="3" md="6" order-md="2" lg="3" order-lg="2" class="px-4 px-md-2 px-lg-4 viewer fade">
					<h6 class="m-0 pb-4 text-graydark text-uppercase" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<span v-if="$creo.getLang() == 'sv'">ÅTERFÖRING</span>
						<span v-else>Distribrution</span>

					</h6>
				</b-col>
				<b-col cols="12" order="5" md="6" order-md="5" lg="3" order-lg="3" class="px-4 px-md-0 px-lg-4 viewer fade">
					<h6 class="m-0 pb-4 text-graydark text-uppercase" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<span v-if="$creo.getLang() == 'sv'">SOLIDITET</span>
						<span v-else>Equity/Assets ratio</span>

					</h6>
				</b-col>
				<b-col cols="12" order="7" md="6" order-md="6" lg="3" order-lg="4" class="px-0 viewer fade">
					<h6 class="m-0 pb-4 text-graydark text-uppercase" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<span v-if="$creo.getLang() == 'sv'">BYGGRÄTTER</span>
						<span v-else>Building rights</span>

					</h6>
				</b-col>
				<b-col cols="10" offset="1" order="2" md="6" offset-md="0" order-md="3" lg="3" offset-lg="0" order-lg="5" class="px-0 px-xl-4 pt-2 border-right viewer fade">
					<div id="barChartContainer1" class="chart1 text-center px-4">
						<b-row class="px-2 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<b-col cols="6" class="text-left ">
								<p class="px-2 mb-0 graf-toptext">%</p>
							</b-col>
							<b-col cols="6" class="text-right">
								<p class="px-2 mb-0 graf-toptext"></p>
							</b-col>
						</b-row>
						<c-bar-chart 	:cData="barChart.data"
										:cOptions="barChart.options"
										key="barChart1"
										 v-if="showChart"/>

					</div>
					<b-row class="align-items-center pt-lg-4 px-5 pl-lg-5 pr-lg-0" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<b-col cols="auto" class="pl-2 pr-0 text-graydark">
							<div class="d-flex align-items-center ">
								<span class="legend-brick mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">JM</span>
									<span v-else>JM</span>
									</p>
							</div>
						</b-col>
						<b-col class="pl-3 text-graydark">
							<div class="d-flex align-items-center mr-lg-2">
								<span class="legend-gold mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext position-absolute pl-3">
									<span v-if="$creo.getLang() == 'sv'">Genomsnitt jämförbara bolag</span>
									<span v-else>Average, comparable companies</span>
									</p>
							</div>
						</b-col>
						<b-col cols="12" class="pl-2 text-graydark">
							<div class="d-flex align-items-center mr-3 mr-lg-2 pt-2">
								<span class="legend-grey mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">Nasdaq Stockholm</span>
									<span v-else>Nasdaq Stockholm</span>
									</p>
							</div>
						</b-col>
						<b-col cols="12" order="1" order-lg="1" class="px-0 d-lg-none py-2">
							<div class="pt-4 px-0">
								<p class="px-lg-1 mb-2 medium JMSerif">
									<span v-if="$creo.getLang() == 'sv'">God långsiktig<br> totalavkastning</span>
									<span v-else>Good long-term <br>total return</span>
								</p>
								<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
									<span v-if="$creo.getLang() == 'sv'">Aktien är volatil men har skapat god totalavkastning långsiktigt.</span>
									<span v-else>The share is volatile,
												but it has created good total
												return in the long run.</span>
								</h6>
							</div>
						</b-col>
					</b-row>
					<hr class="mt-4 pb-4 d-md-none" />
				</b-col>
				<b-col cols="10" offset="1" order="4" md="6" offset-md="0" order-md="4" lg="3" offset-lg="0" order-lg="6" class="px-0 px-xl-4 pt-2 border-right viewer fade">
					<div id="barChartContainer2" class="chart1 text-center px-4">
						<b-row class="px-2 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<b-col cols="6" class="text-left">
								<p class="px-2 mb-0 graf-toptext">
									<span v-if="$creo.getLang() == 'sv'">Mkr</span>
									<span v-else>SEKm</span>
								</p>
							</b-col>
							<b-col cols="6" class="text-right">
								<p class="px-2 mb-0 graf-toptext"></p>
							</b-col>
						</b-row>
						<c-bar-chart 	:cData="barChart.data2"
										:cOptions="barChart.options"
										key="barChart2"
										v-if="showChart"/>
					</div>
					<b-row class="align-items-center pt-lg-4 px-5 pl-lg-5 pr-lg-0" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<b-col cols="12" class="pl-2 text-graydark">
							<div class="d-flex align-items-center mr-3 mr-lg-2 ">
								<span class="legend-grey mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">Återköp av aktier</span>
									<span v-else>Buy-back of shares</span>
									</p>
							</div>
						</b-col>
						<b-col cols="12" class="pl-2 pr-0 pt-2 text-graydark">
							<div class="d-flex align-items-center">
								<span class="legend-brick mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">Utdelning</span>
									<span v-else>Dividend</span>
									</p>
							</div>
						</b-col>
						<b-col cols="12" order="1" order-lg="1" class="p-0 d-lg-none py-2">
							<div class=" pt-4 px-0">
								<p class="px-1 mb-2 medium JMSerif">
									<span v-if="$creo.getLang() == 'sv'">Ökande utdelning<br> över lång tid</span>
									<span v-else>Increasing dividend over long period of time</span>
								</p>
								<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
									<span v-if="$creo.getLang() == 'sv'">JM har haft en ökande utdelning över lång tid i kombination med ett flertal kapitalutskiftningar över åren.</span>
									<span v-else>JM’s dividend has increased over a long period of time combined with multiple capital distributions over the years.</span>
									</h6>
							</div>
						</b-col>
					</b-row>
					<hr class="mt-4 pb-4 d-md-none" />
				</b-col>
				<b-col cols="10" offset="1" order="6" md="6" offset-md="0" order-md="7" lg="3" offset-lg="0" order-lg="7" class="px-0 px-xl-4 pt-2 border-right viewer fade">
					<div id="barChartContainer3" class="chart1 text-center px-4">
						<b-row class="px-2 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<b-col cols="6" class="text-left">
								<p class="px-2 mb-0 graf-toptext">%</p>
							</b-col>
							<b-col cols="6" class="text-right">
								<p class="px-2 mb-0 graf-toptext"></p>
							</b-col>
						</b-row>
						<c-bar-chart 	:cData="barChart.data3"
										:cOptions="barChart.options"
										:height="400"
										key="barChart3"
										 v-if="showChart"/>
					</div>
					<b-row class="align-items-center pt-lg-4 px-5 pl-lg-5 pr-lg-0 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
						<b-col cols="12" class="pl-2 pr-0">
							<div class="d-flex align-items-center">
								<span class="legend-brick mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">Soliditet</span>
									<span v-else>Equity/Assets ratio</span>
									</p>
							</div>
						</b-col>
						<b-col cols="12" class="pl-2 pt-3 pr-0">
							<div class="d-flex align-items-center">
								<span class=" mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">

									</p>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" order="1" order-lg="1" class="px-5 d-lg-none pb-lg-5">
							<div class=" pt-4 px-0">
								<p class="px-1 mb-2 medium">
									<span v-if="$creo.getLang() == 'sv'">Stark<br> balansräkning</span>
									<span v-else>Strong balance sheet</span>
									</p>
								<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
									<span v-if="$creo.getLang() == 'sv'">En stark soliditet är en förutsättning för stabil och kostnadseffektiv finansiering av pågående bostadsproduktion.</span>
									<span v-else>A strong equity/assets ratio is a prerequisite for stable and cost-effective financing of ongoing housing production.</span>
									</h6>
							</div>
						</b-col>
					</b-row>
					<hr class="mt-4 pb-4 d-md-none" />
				</b-col>
				<b-col cols="10" offset="1" order="8" md="6" offset-md="0" order-md="8" lg="3" offset-lg="0" order-lg="8" class="px-0 px-xl-3 pt-2  viewer fade">
					<div id="barChartContainer4" class="chart1  text-center px-1">
						<b-row class="px-4 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<b-col cols="6" class="text-left">
								<p class="px-2 mb-0 graf-toptext">
									<span v-if="$creo.getLang() == 'sv'">Antal, tusental</span>
									<span v-else>Number (000)</span>
									</p>
							</b-col>
							<b-col cols="6" class="text-right">
								<p class="px-2 mb-0 graf-toptext">
									<span v-if="$creo.getLang() == 'sv'">Mdkr</span>
									<span v-else>SEK bn</span>
								</p>
							</b-col>
						</b-row>
						<c-mix-chart 	:cData="mixedChart.data"
										:cOptions="mixedChart.options"
										key="barChart4"
										v-if="showChart"/>

					</div>
					<b-row class="align-items-center pt-lg-4 pl-lg-3" >
						<b-col cols="7" class="pr-0 text-graydark" :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<div class="d-flex align-items-center mr-3 mr-lg-2">
								<span class="legend-grey mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext">
									<span v-if="$creo.getLang() == 'sv'">Villkorade byggrätter</span>
									<span v-else>Conditional building rights</span>
									</p>
							</div>
							<div class="d-flex align-items-center pt-2 text-graydark">
								<span class="legend-brick mr-1 d-inline-block ">
								</span>
								<p class="m-0 graf-subtext position-absolute pl-3">
									<span v-if="$creo.getLang() == 'sv'">Byggrätter i balansräkningen</span>
									<span v-else>Building rights in the balance sheet</span>
									</p>
							</div>
						</b-col>
						<b-col cols="5" class="px-0 pb-2 text-graydark">
							<div class="d-flex align-items-center ">
								<span class="legend-line-gold mr-1 d-inline-block mb-special">
								</span>
								<p class="m-0 graf-subtext text-left gillSansjm">
									<span v-if="$creo.getLang() == 'sv'">Övervärde byggrätter<br> i balansräkning</span>
									<span v-else>Surplus value building<br> rights in balance sheet</span>
								</p>
							</div>
						</b-col>
						<b-col cols="12" order="1" order-lg="1" class="px-4 d-lg-none pb-4">
							<div class=" pt-4 px-0">
								<p class="px-1 mb-2 medium">
									<span v-if="$creo.getLang() == 'sv'">Byggrättsportfölj<br> med stor värdepotential</span>
									<span v-else>Building rights portfolio with great value potential</span>
								</p>
								<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
									<span v-if="$creo.getLang() == 'sv'">JM har 37 800 byggrätter för framtida projektutveckling, varav 20 400 redovisas i balansräkningen.</span>
									<span v-else>JM has 37,800 building rights for future project development, of which 20,400 are reported in the balance sheet.</span>
								</h6>
							</div>
						</b-col>
					</b-row>

				</b-col>

			</b-row>
			<b-row class="pt-0 d-none d-lg-flex">
				<b-col cols="12" order="1" md="6" order-md="1" lg="3" order-lg="1" class="px-4">
					<div class=" pt-4 px-0">
						<p class="px-1 mb-2 medium">
							<span v-if="$creo.getLang() == 'sv'">God långsiktig<br> totalavkastning</span>
							<span v-else>Good long-term <br>total return </span>
						</p>
						<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<span v-if="$creo.getLang() == 'sv'">Aktien är volatil men har skapat god totalavkastning långsiktigt.</span>
							<span v-else>The share is volatile,
										but it has created good total
										return in the long run.
							</span>
						</h6>
					</div>
				</b-col>
				<b-col cols="12" order="3" md="6" order-md="2" lg="3" order-lg="2" class="px-4 ">
					<div class=" pt-4 px-0">
						<p class="px-1 mb-2 medium">
							<span v-if="$creo.getLang() == 'sv'">Ökande utdelning<br> över lång tid</span>
							<span v-else>Increasing dividend over long period of time</span>
						</p>
						<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<span v-if="$creo.getLang() == 'sv'">JM har haft en ökande utdelning över lång tid i kombination med ett flertal kapitalutskiftningar över åren.</span>
							<span v-else>JM’s dividend has increased over a long period of time combined with multiple capital distributions over the years.</span>
						</h6>
					</div>
				</b-col>
				<b-col cols="12" order="5" md="6" order-md="5" lg="3" order-lg="3" class="px-4">
					<div class=" pt-4 px-0">
						<p class="px-1 mb-2 medium">
							<span v-if="$creo.getLang() == 'sv'">Stark<br> balansräkning</span>
							<span v-else>Strong balance<br> sheet</span>
						</p>
						<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<span v-if="$creo.getLang() == 'sv'">En stark soliditet är en förutsättning för stabil och kostnadseffektiv finansiering av pågående bostadsproduktion.</span>
							<span v-else>A strong equity/assets ratio is a prerequisite for stable and cost-effective financing of ongoing housing production.</span>
						</h6>
					</div>
				</b-col>
				<b-col cols="12" order="7" md="6" order-md="6" lg="3" order-lg="4" class=" ">
					<div class=" pt-4 px-0">
						<p class="px-1 mb-2 medium">
							<span v-if="$creo.getLang() == 'sv'">Byggrättsportfölj<br> med stor värdepotential</span>
							<span v-else>Building rights portfolio with great value potential</span>
						</p>
						<h6 :class="this.$creo.get_browser()? 'gillSansjm' : 'gillSans'">
							<span v-if="$creo.getLang() == 'sv'">JM har 37 800 byggrätter för framtida projektutveckling, varav 20 400 redovisas i balansräkningen.</span>
							<span v-else>JM has 37,800 building rights for future project development, of which 20,400 are reported in the balance sheet.</span>
						</h6>
					</div>
				</b-col>
			</b-row>
				<b-row class="" v-view="viewHandler">
					<b-col cols="12" class="text-center pt-lg-4 pb-4 viewer fade">
						<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-lg-3 italic text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
						</a>
					</b-col>
				</b-row>
			</b-container>
		<c-fullscreen-image :image_class="'bg-morgon'" ref="section"/>
	</section>
</template>
<script>
	import CBarChart 		from '@/components/BarChart.vue'
	import CMixChart 		from '@/components/MixChart.vue'
	import CFullscreenImage from '@/components/FullscreenImage.vue'
	export default {
		props: {
			pdfLink: Object
		},
		components: {
			CBarChart,
			CMixChart,
			CFullscreenImage
		},
		data() {
			return {
				showChart: false,
				mixedChart: {
					data: {
						labels: ['2016', '2017', '2018', '2019', '2020'],
						datasets: [{

							type: 'line',
							responsive: true,
							yAxisID: 'B',
							data: [ 7, 7.2, 7, 6.7, 6.5],
							fill: false,
							pointRadius: 0,
							borderWidth: 3,
							borderColor: [
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',
							],
							backgroundColor: [
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',
								'#e2ad41',

							],
						},{

							barPercentage: 1,
							categoryPercentage: 0.65,
							responsive: true,
							minBarLength: 2,
							yAxisID: 'A',
							stack: 'Stack 2',
							data: [17900, 18700, 20700, 21100, 20100],
							backgroundColor: [
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						},
						{
							barPercentage: 1,
							categoryPercentage: 0.65,
							responsive: true,
							minBarLength: 2,
							yAxisID: 'A',
							stack: 'Stack 2',
							data: [14600, 16100, 15200, 14800, 17400],

							backgroundColor: [
								'#c6c5c0',
								'#c6c5c0',
								'#c6c5c0',
								'#c6c5c0',
								'#c6c5c0',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						}]
					},
					options: {
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									var value = String(tooltipItem.value)
								  return  this.$creo.getLang() == 'sv' ? value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 "): value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
								}.bind(this),
							},
						},
						responsive: true,
						maintainAspectRatio: false,
						layout: {
							padding: {
								left: 30,
								right: 30,
								top: 10,
								bottom: 0
							}
						},
						plugins: {
							datalabels: {
								anchor: 'end',
								align: 'end',
								color: '#4D4D55',
								formatter: function(value, context) {
				                    return '';
				                },
								font: [
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
								]
							}
						},
						legend: {
							display: false
						},
						scales: {
							x1: {
								stacked: true,
							},
							x2: {
								stacked: true,
							},
							y: {
								stacked: true
							},
							yAxes: [{
								id: 'A',
								type: 'linear',
								position: 'left',
								ticks: {
										callback: function(value, index, values) {
										   return  value/1000;
									    },
										display: true,
										beginAtZero: true,
										fontColor: '#4D4D55',
										fontSize: 8,
									},
									gridLines: {
									display: true,
									width: 0.5,
									color: '#fff',
									drawBorder: false,
									lineWidth: 1,
									zeroLineWidth: 2,
									zeroLineColor: '#666',
									tickMarkLength: 0,

								}
								 }, {
									id: 'B',
	 								type: 'linear',
	 								position: 'right',
								  	ticks: {
	  									display: true,
	  									beginAtZero: true,
	  									fontColor: '#4D4D55',
	  									fontSize: 8,
  									},
									gridLines: {
									display: true,
									width: 0.5,
									color: '#bbb',
									drawBorder: false,
									lineWidth: 1,
									zeroLineWidth: 2,
									zeroLineColor: '#666',
									tickMarkLength: 0,

								}


							}],
							xAxes: [{
								ticks: {
									display: true,
									beginAtZero: false,
									fontColor: '#333333',
									fontSize: 8
								},
								gridLines: {
									display: false,


								}
							}]
						}
					}
				},
				barChart: {
					data: {
						labels: ['2016-2020', '2011-2020'],
						datasets: [{
							labels: '1',
							barPercentage: 0.9,
							categoryPercentage: 0.8,
							responsive: true,
							minBarLength: 2,
							data: [8, 11],
							backgroundColor: [
								'#d15c05',
								'#d15c05',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',

							]
						},
						{
							labels: '2',
							barPercentage: 0.9,
							categoryPercentage: 0.8,
							responsive: true,
							minBarLength: 2,
							data: [ 6, 7],
							backgroundColor: [
								'#e2ad41',
								'#e2ad41',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',

							]
						},
						{
							labels: '3',
							barPercentage: 0.9,
							categoryPercentage: 0.8,
							responsive: true,
							minBarLength: 2,
							data: [12, 11],
							backgroundColor: [
								'#c6c5c0',
								'#c6c5c0',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						},]
					},
					data2: {
						labels: ['2016', '2017', '2018', '2019', '2020'],
						datasets: [{
							barPercentage: 1,
							categoryPercentage: 0.65,
							responsive: true,
							minBarLength: 2,
							stack: 'Stack 0',
							data: [602, 675, 765, 835, 870],
							backgroundColor: [
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',

							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						},
						{
							barPercentage: 1,
							categoryPercentage: 0.65,
							responsive: true,
							minBarLength: 2,
							stack: 'Stack 0',
							data: [500, 500],
							backgroundColor: [
								'#c6c5c0',
								'#c6c5c0',
								'#c6c5c0',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						}]
					},
					data3: {
						labels: ['2016', '2017', '2018', '2019', '2020'],
						datasets: [{
							barPercentage: 1,
							categoryPercentage: 0.65,
							responsive: true,
							minBarLength: 2,
							data: [40, 40, 41, 42, 47],
							backgroundColor: [
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',
								'#d15c05',
							],
							borderWidth: 0,
							borderColor: [
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
								'#4D4D55',
							]
						}]
					},

					options: {
						responsive: true,
						maintainAspectRatio: false,
						layout: {
							padding: {
								left: 10,
								right: 10,
								top: 10,
								bottom: 0
							}
						},
						plugins: {
							tooltip: {
								mode: 'index',
								intersect: false
							},
							datalabels: {
								anchor: 'end',
								offset: -5,
								align: 'end',
								color: '#4D4D55',
								formatter: function(value, context) {
								 	if (value == 602 ) {
										return ''
									} else if (value == 675 ) {
										return ''
									} else if (value == 500 && context.dataIndex == 0) {
										return this.$creo.getLang() == 'sv' ? '1 102' : '1,102'
									} else if (value == 500 && context.dataIndex == 1) {
										return this.$creo.getLang() == 'sv' ? '1 175' : '1,175'
									}
				                    return value;
				                }.bind(this),
								font: [
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
									{
										size: 9,
										weight: 400
									},
								]
							}
						},
						legend: {
							display: false
						},
						scales: {
							x: {
								stacked: true,
							},
							y: {
								stacked: true
							},
							yAxes: [{
								ticks: {
									display: true,
									beginAtZero: true,
									fontColor: '#4D4D55',
									fontSize: 8,
								},
								gridLines: {
									display: true,
									width: 0.5,
									color: '#ccc',
									drawBorder: false,
									lineWidth: 1,
									borderDashOffset: 6,
									zeroLineWidth: 2,
									zeroLineColor: '#666',
									tickMarkLength: 0,
								}
							}],
							xAxes: [{
								ticks: {
									display: true,
									beginAtZero: false,
									fontColor: '#333333',
									fontSize: 8
								},
								gridLines: {
									drawBorder: false,
									display: false,

									lineWidth: 0,
									zeroLineColor: '#fff',
									color: "rgba(0, 0, 0, 0)",
								},
								zeroLine: {
									display: false,
								}
							}]
						}
					}
				},

			}
		},
		methods: {
			viewHandler(e) {
				const id = e.target.element.id
				if(id === 'charts' && e.type === 'enter' || id === 'charts' && e.type === 'progress') {
					setTimeout(function() {
						this.showChart = true
					}.bind(this), 1000)
				} else if(id === 'charts') {
					this.showChart = false
				}
			}
		}
	}
</script>
